import { useContext, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';
import useService from '../useService';

type CheckResult = {
	found: boolean;
	segmentName: string;
	userSegments: string[];
};

const useCheckUserSegment = () => {
	const [userId, setUserId] = useState('');
	const [segmentName, setSegmentName] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState<CheckResult | null>(null);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCheckUserLiveSegment } = useService();

	const handleCheck = useCallback(async () => {
		if (!userId.trim()) {
			showAlert('Please enter a Zupee User ID', { type: 'error' });
			return;
		}
		if (!segmentName.trim()) {
			showAlert('Please enter a Segment Name', { type: 'error' });
			return;
		}

		setLoading(true);
		setResult(null);

		try {
			const data = await requestCheckUserLiveSegment(userId.trim(), segmentName.trim());

			if (!data.success) {
				showAlert(data.error || 'Error checking user segment', { type: 'error' });
				setLoading(false);
				return;
			}

			setResult({
				found: data.isInSegment,
				segmentName: data.segmentName,
				userSegments: data.userSegments || []
			});
		} catch (err: any) {
			const errorMsg = err?.response?.data?.error || err?.error || 'Error checking user segment';
			showAlert(errorMsg, { type: 'error' });
		} finally {
			setLoading(false);
		}
	}, [userId, segmentName, requestCheckUserLiveSegment, showAlert]);

	const handleBack = useCallback(() => {
		history.goBack();
	}, [history]);

	return {
		userId,
		setUserId,
		segmentName,
		setSegmentName,
		loading,
		result,
		handleCheck,
		handleBack
	};
};

export default useCheckUserSegment;
